export default "__VITE_ASSET__GnEs6Hcl__"